const Cart = () => {
  return (
    <svg
      width="38"
      height="25"
      viewBox="0 0 38 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 3.40039L4.81045 3.8688C4.92598 3.88805 5.01974 3.97278 5.05056 4.08578L5.68182 6.40039M8 13.9004V17.1004C8 17.2661 8.13431 17.4004 8.3 17.4004H17.5M8 13.9004H18.7969C18.9196 13.9004 19.0299 13.8257 19.0754 13.7118L21.8354 6.81181C21.9143 6.61475 21.7691 6.40039 21.5569 6.40039H5.68182M8 13.9004L5.68182 6.40039M17.5 17.4004C16.3954 17.4004 15.5 18.2958 15.5 19.4004C15.5 20.505 16.3954 21.4004 17.5 21.4004C18.6046 21.4004 19.5 20.505 19.5 19.4004C19.5 18.2958 18.6046 17.4004 17.5 17.4004ZM12.5 19.4004C12.5 20.505 11.6046 21.4004 10.5 21.4004C9.39543 21.4004 8.5 20.505 8.5 19.4004C8.5 18.2958 9.39543 17.4004 10.5 17.4004C11.6046 17.4004 12.5 18.2958 12.5 19.4004Z"
        stroke="#1A1919"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <g clipPath="url(#clip0_426_21974)">
        <path
          d="M29 12.4004H37"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M33 16.4004L33 8.40039"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_426_21974">
          <rect
            width="10"
            height="10"
            fill="white"
            transform="translate(28 7.40039)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Cart;
